import { render, staticRenderFns } from "./menu_set_phone.vue?vue&type=template&id=420c712c&scoped=true"
import script from "./menu_set_phone.vue?vue&type=script&lang=js"
export * from "./menu_set_phone.vue?vue&type=script&lang=js"
import style0 from "./menu_set_phone.vue?vue&type=style&index=0&id=420c712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420c712c",
  null
  
)

export default component.exports